import { motion } from "framer-motion";
import comPro from "../../../Assets/Images/verified.png";
import pro_in_prog from "../../../Assets/Images/progression.png";
import satisCli from "../../../Assets/Images/rating.png";
import awardRe from "../../../Assets/Images/award.png";
import SectionHeading from "../../SectionHeading";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/DemoExcel.css";

const STATS = [
  { img: pro_in_prog, value: "10+", label: "Projects in progress" },
  { img: comPro, value: "30+", label: "Completed projects" },
  { img: satisCli, value: "25+", label: "Satisfied clients" },
  { img: awardRe, value: "12", label: "Awards received" },
];

const DemoExcel = () => {
  return (
    <section className="section stats">
      <div className="container">
        <SectionHeading
          eyebrow="Impressive track record"
          title="Demonstrating excellence"
        />

        <motion.div className="stats__grid" variants={stagger} {...revealOnce}>
          {STATS.map((stat) => (
            <motion.div key={stat.label} className="stat-card" variants={fadeUp}>
              <img className="stat-card__icon" src={stat.img} alt="" aria-hidden="true" loading="lazy" />
              <span className="stat-card__value">{stat.value}</span>
              <span className="stat-card__label">{stat.label}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default DemoExcel;
